import { action, makeObservable, observable } from 'mobx'

export default class DependentFieldsStore {
  @observable public isCreatingNewRule: boolean = false
  @observable public areRulesHidden: boolean = false
  @observable public areInactiveRulesShown: boolean = false
  @observable public expandedRuleKey: string | null = null

  public constructor() {
    makeObservable(this)
  }

  @action.bound
  public resetAll() {
    this.isCreatingNewRule = false
    this.expandedRuleKey = null
  }

  @action.bound
  public toggleRules() {
    this.areRulesHidden = !this.areRulesHidden
  }

  @action.bound
  public toggleInactiveRules() {
    this.areInactiveRulesShown = !this.areInactiveRulesShown
  }

  @action.bound
  public toggleRule(ruleKey: string) {
    this.cancelNewRule()
    this.expandedRuleKey = this.expandedRuleKey === ruleKey ? null : ruleKey
  }

  @action.bound
  public startCreatingNewRule() {
    this.expandedRuleKey = null
    this.isCreatingNewRule = true
    this.areRulesHidden = false
    this.areInactiveRulesShown = false
  }

  @action.bound
  public cancelNewRule() {
    this.isCreatingNewRule = false
  }

  @action.bound
  public completeRuleCreation() {
    this.isCreatingNewRule = false
  }
}
